import React from 'react';
import { Box, Link as MuiLink } from '@mui/material';

const ResourceLinks = ({ slides, media, document, certificate, poster, doi }) => {
  const renderLinks = (label, data) => {
    if (!data) return null;

    if (Array.isArray(data)) {
      return data.map((item, index) => (
        <MuiLink
          key={`${label}-${index}`}
          href={item}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ marginRight: 2 }}
        >
          [{label} {index + 1}]
        </MuiLink>
      ));
    }

    return (
      <MuiLink href={data} target="_blank" rel="noopener noreferrer" sx={{ marginRight: 2 }}>
        [{label}]
      </MuiLink>
    );
  };

  return (
    <Box
      sx={{
        marginTop: 1,
        paddingLeft: 2,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {renderLinks('Slides', slides)}
      {renderLinks('Media', media)}
      {renderLinks('Document', document)}
      {renderLinks('Certificate', certificate)}
      {renderLinks('Poster', poster)}
      {renderLinks('DOI', doi)}
    </Box>
  );
};

export default ResourceLinks;
